var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrand24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_brand24x24",
    transform: "translate(-3 -3)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46246",
    d: "M7.633,14.571a5.94,5.94,0,0,1-.8-1.871H3a8.852,8.852,0,0,0,1.871,4.633Z",
    transform: "translate(0 -1.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46247",
    d: "M6.92,10.733a3.547,3.547,0,0,1,.8-1.871L4.871,6.1A8.18,8.18,0,0,0,3,10.733Z",
    transform: "translate(0 -.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46248",
    d: "M8.862,7.633a5.94,5.94,0,0,1,1.871-.8V3A8.852,8.852,0,0,0,6.1,4.871Z",
    transform: "translate(-.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46249",
    d: "M12.7,3V6.92a3.547,3.547,0,0,1,1.871.8L17.333,4.96A8.294,8.294,0,0,0,12.7,3Z",
    transform: "translate(-1.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46250",
    d: "M15.8,8.862a5.94,5.94,0,0,1,.8,1.871h3.831A8.852,8.852,0,0,0,18.562,6.1Z",
    transform: "translate(-1.433 -.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46251",
    d: "M10.733,16.5a3.547,3.547,0,0,1-1.871-.8L6.1,18.462a8.18,8.18,0,0,0,4.633,1.871Z",
    transform: "translate(-.347 -1.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46252",
    d: "M16.5,12.7a3.547,3.547,0,0,1-.8,1.871l2.762,2.762A8.18,8.18,0,0,0,20.333,12.7Z",
    transform: "translate(-1.422 -1.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46253",
    d: "M14.571,15.8a5.94,5.94,0,0,1-1.871.8v3.831a8.852,8.852,0,0,0,4.633-1.871Z",
    transform: "translate(-1.086 -1.433)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrand24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand24x24.e00d85547f034f7fa60a8a3670c25fc7.svg";